import { AppDispatch, RootState } from '../../../store'
import { CollectionCreationStep, CollectionType, TeamCollection } from './types'
import { DUMMY_SUGGESTED_MEMBER_IDS } from './dummyMembers'

export enum TeamRelationshipActionTypes {
  OPEN_CREATE_COLLECTION = 'TEAM_RELATIONSHIP_OPEN_CREATE_COLLECTION',
  CLOSE_CREATE_COLLECTION = 'TEAM_RELATIONSHIP_CLOSE_CREATE_COLLECTION',
  SET_CREATION_STEP = 'TEAM_RELATIONSHIP_SET_CREATION_STEP',
  SET_DRAFT_COLLECTION_TYPE = 'TEAM_RELATIONSHIP_SET_DRAFT_COLLECTION_TYPE',
  SET_DRAFT_COLLECTION_NAME = 'TEAM_RELATIONSHIP_SET_DRAFT_COLLECTION_NAME',
  SET_DRAFT_SELECTED_MEMBER_IDS = 'TEAM_RELATIONSHIP_SET_DRAFT_SELECTED_MEMBER_IDS',
  TOGGLE_DRAFT_MEMBER = 'TEAM_RELATIONSHIP_TOGGLE_DRAFT_MEMBER',
  ADD_COLLECTION = 'TEAM_RELATIONSHIP_ADD_COLLECTION',
  SET_COLLECTIONS = 'TEAM_RELATIONSHIP_SET_COLLECTIONS',
  RESET_TEAM_RELATIONSHIP = 'TEAM_RELATIONSHIP_RESET',
}

export const openCreateCollection = () =>
  ({
    type: TeamRelationshipActionTypes.OPEN_CREATE_COLLECTION,
  }) as const

export const closeCreateCollection = () =>
  ({
    type: TeamRelationshipActionTypes.CLOSE_CREATE_COLLECTION,
  }) as const

export const setCreationStep = (step: CollectionCreationStep) =>
  ({
    type: TeamRelationshipActionTypes.SET_CREATION_STEP,
    payload: step,
  }) as const

export const setDraftCollectionType = (collectionType: CollectionType) =>
  ({
    type: TeamRelationshipActionTypes.SET_DRAFT_COLLECTION_TYPE,
    payload: collectionType,
  }) as const

export const setDraftCollectionName = (name: string) =>
  ({
    type: TeamRelationshipActionTypes.SET_DRAFT_COLLECTION_NAME,
    payload: name,
  }) as const

export const setDraftSelectedMemberIds = (memberIds: string[]) =>
  ({
    type: TeamRelationshipActionTypes.SET_DRAFT_SELECTED_MEMBER_IDS,
    payload: memberIds,
  }) as const

export const toggleDraftMember = (memberId: string) =>
  ({
    type: TeamRelationshipActionTypes.TOGGLE_DRAFT_MEMBER,
    payload: memberId,
  }) as const

export const addCollection = (collection: TeamCollection) =>
  ({
    type: TeamRelationshipActionTypes.ADD_COLLECTION,
    payload: collection,
  }) as const

export const setCollections = (collections: TeamCollection[]) =>
  ({
    type: TeamRelationshipActionTypes.SET_COLLECTIONS,
    payload: collections,
  }) as const

export const resetTeamRelationship = () =>
  ({
    type: TeamRelationshipActionTypes.RESET_TEAM_RELATIONSHIP,
  }) as const

export const continueFromCollectionType =
  (collectionType: CollectionType) => (dispatch: AppDispatch) => {
    dispatch(setDraftCollectionType(collectionType))
    dispatch(setCreationStep('nameCollection'))
  }

export const continueFromCollectionName =
  () => (dispatch: AppDispatch, getState: () => RootState) => {
    const { draft } = getState().teamRelationship
    if (!draft.name.trim()) {
      return
    }
    // Seed suggested AEs the first time we enter the members step.
    if (!draft.selectedMemberIds.length) {
      dispatch(setDraftSelectedMemberIds(DUMMY_SUGGESTED_MEMBER_IDS))
    }
    dispatch(setCreationStep('selectMembers'))
  }

export const goBackToCollectionTypeSelection =
  () => (dispatch: AppDispatch) => {
    dispatch(setCreationStep('selectType'))
  }

export const createCollectionId = () =>
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `collection-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`

export const createCollectionFromDraft =
  () => (dispatch: AppDispatch, getState: () => RootState) => {
    const { draft } = getState().teamRelationship
    const name = draft.name.trim()
    if (!draft.type || !name) {
      return
    }

    const collection: TeamCollection = {
      id: createCollectionId(),
      name,
      type: draft.type,
      memberIds: [...draft.selectedMemberIds],
      createdAt: new Date().toISOString(),
    }

    dispatch(addCollection(collection))
    dispatch(closeCreateCollection())
  }
